import { useEffect, useState }     from 'preact/hooks';
import { createDirectus, graphql } from '@directus/sdk';

const useKeepExploringData = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    const client = createDirectus(import.meta.env.VITE_DIRECTUS_API_URL).with(graphql());
    try {
      const result = await client.query(`
       query {
          global_asset(filter: {title: {_eq: "keep-exploring"}}) {
              title
              asset {
                  rlx_responsive_asset_id {
                      title
                      asset_landscape {
                          id
                      }
                      asset_portrait {
                          id
                      }
                  }
              }
          }
      }
      `)
      setData(result);
      setIsLoading(false);
    } catch (error) {
      setError(error);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchData()
  }, []);


  return { data, isLoading, error };

};

export default useKeepExploringData;
